import { render, staticRenderFns } from "./PatientMedicalRecordsModal__Style#Drawer.vue?vue&type=template&id=62decf1f&scoped=true&"
import script from "./PatientMedicalRecordsModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./PatientMedicalRecordsModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./PatientMedicalRecordsModal__Style#Drawer.vue?vue&type=style&index=0&id=62decf1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62decf1f",
  null
  
)

export default component.exports